export default "__VITE_PUBLIC_ASSET__b002a678__"